import React from "react";
import { Row } from "react-bootstrap";
import RowItem from "./RowItemAdmin";
import RowItemMobile from "./RowItemMobile";

const AdminCardBody = ({
  data,
  type,
  linkTitle,
  moduleid,
  fetchLearningModuleData,
}: {
  data: any;
  type?: number;
  linkTitle?: any;
  moduleid: number;
  fetchLearningModuleData: any;
}) => {
  //console.log(data,moduleid, "modelchecking")
  return (
    <>
      <div className="desk">
        <Row style={styles.rowBg}>
          {data.map((item: any, type: any) => {
            return (
              <RowItem
                key={`${moduleid}${item?.id}`}
                item={item}
                type={type}
                moduleid={moduleid}
                fetchLearningModuleData={fetchLearningModuleData}
              />
            );
          })}
        </Row>
      </div>
      <div className="mob px-0" style={{ marginTop: "0px" }}>
        <Row style={styles.rowBgMob}>
          {data.map((item: any) => {
            return (
              <RowItemMobile
                key={`${moduleid}${item?.id}`}
                item={item}
                linkTitle={linkTitle}
              />
            );
          })}
        </Row>
      </div>
    </>
  );
};

const styles: any = {
  borderRadius: {
    borderRadius: "50%",
  },
  rowBg: {
    backgroundColor: "#ffffff",
    paddingTop: "16px",
    paddingBottom: "0px",
    // margin: "auto",
  },
  rowBgMob: {
    backgroundColor: "#ffffff",
    // paddingTop: "16px",
    paddingBottom: "0px",
  },
};

export default AdminCardBody;
